import { portalPaths } from '@provision/portal-routes/dist/paths';
import { DATA_CONVERSATION_FRIENDLY_ID, DATA_ENTITY_TYPE, DATA_PARTNER_PREFIX } from './const';
import { UIReplacerName } from './types';

const ICON_SELECTOR = '[class*="material-symbols"]';

/**
 * Turns the HTML rendered into a message bubble into HTML that survives leaving the portal.
 *
 * The conversation chip is a span carrying a Material Symbols icon whose text content is the
 * ligature name, so without the portal's font it reads as the literal word `chat_bubble`. The
 * chip also replaced the anchor it was built from, so a pasted link is no longer clickable.
 */
export function getPortableHtmlFromDisplayHtml(html?: string | null): string {
  if (!html) {
    return '';
  }

  const container = document.createElement('div');
  container.innerHTML = html;

  container
    .querySelectorAll(`[${DATA_ENTITY_TYPE}="${UIReplacerName.ConversationLink}"]`)
    .forEach((chip) => {
      const conversationFriendlyId = chip.getAttribute(DATA_CONVERSATION_FRIENDLY_ID) ?? '';
      const partnerPrefix = chip.getAttribute(DATA_PARTNER_PREFIX) ?? '';

      chip.querySelectorAll(ICON_SELECTOR).forEach((icon) => icon.remove());

      const label = chip.textContent?.trim() ?? '';

      if (!conversationFriendlyId) {
        chip.replaceWith(container.ownerDocument.createTextNode(label));
        return;
      }

      const anchor = container.ownerDocument.createElement('a');
      anchor.href = `${window.location.origin}${
        partnerPrefix ? `/${partnerPrefix}` : ''
      }${portalPaths.conversation.full(conversationFriendlyId)}`;
      anchor.textContent = label;
      chip.replaceWith(anchor);
    });

  return container.innerHTML;
}
